import styles from './Section01.module.css';
import Aurora from '../Ui/Aurora';
import BlurText from "../Ui/BlurText";
import { Link } from 'react-router-dom';

function Section01() {
    return (
        <div className={styles.section01}>
            <Aurora
                colorStops={["#FFBB27", "#FF3736", "#FF5ABD", "#2C67FF", "#2FFFBB"]}
                blend={3.5}
                amplitude={1.1}
                speed={1.1}
            />
            <div className={styles.section01Container}>
                <div className={styles.section01Content}>
                    <div className={styles.section01TextContainer}>
                        <div className={styles.section01TextWrapper}>
                            <BlurText
                                text="Korea Sensibility"
                                delay={100}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                            <BlurText
                                text="Color Association"
                                delay={100}
                                initialDelay={400}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                        </div>
                        <div className={styles.section01TextWrapperMobile}>
                            <BlurText
                                text="Korea"
                                delay={100}
                                initialDelay={100}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                            <BlurText
                                text="Sensibility"
                                delay={100}     
                                initialDelay={200}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                            <BlurText
                                text="Color"
                                delay={100}
                                initialDelay={300}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                            <BlurText
                                text="Association"
                                delay={100}
                                initialDelay={500}
                                animateBy="words"
                                direction="top"
                                className={styles.section01Text}
                            />
                        </div>
                    </div>
                    <div className={styles.Buttons}>
                        <Link to="/consulting" className={styles.button}>
                            <span>consulting</span>
                        </Link>
                        <Link to="/program" className={styles.button}>
                            <span>program</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div> 
    );
}

export default Section01;



